import { Configuration, Solicitud, SolicitudApi, Aclaracion, EstadoFormalizacion } from '@/shared/formalizacion-client';
import { AxiosResponse, AxiosPromise } from 'axios';
import { Store } from 'vuex';

export default class SolicitudService extends SolicitudApi {
  constructor(microserviceConfigFormalizacion: Configuration, private store: Store<any>) {
    super(microserviceConfigFormalizacion);
  }

  private get solicitud(): Solicitud {
    return this.store.getters.solicitud;
  }

  public getSolicitud(clave: string): Promise<AxiosResponse<Solicitud>> {
    return super
      .getSolicitud(clave)
      .then(res => {
        this.store.commit('setSolicitud', res.data);
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  public getActualSolicitud(): Solicitud {
    return this.solicitud;
  }

  public getActualSolicitudClave(): string {
    return this.solicitud ? this.solicitud.clave : null;
  }

  public getEstadoFormalizacionBySolicitud(clave: string): Promise<AxiosResponse<EstadoFormalizacion>> {
    return super
      .getEstadoFormalizacionBySolicitud(clave)
      .then(res => {
        const solicitud = this.store.getters.solicitud;
        if (solicitud) {
          solicitud.estadoFormalizacion = res.data;
          this.store.commit('setSolicitud', solicitud);
        }
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  public getUltimaAclaracionBySolicitud(solicitudClave: string, options?: any): AxiosPromise<Aclaracion> {
    return super.getUltimaAclaracionBySolicitud(solicitudClave, 0, 1, 'desc', options);
  }
}
